var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._class},[_c('div',{class:_vm._timeClass},[_vm._t("time")],2),_c('div',{class:_vm._rightClass},[_c('div',{class:_vm._contentClass},[_vm._t("content")],2),_c('div',{class:_vm._detailClass},[_vm._t("detail")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }